import React, { useState } from "react";
import Visa from "../assets/VISA.png";
import Diner from "../assets/DinersClub.png";
import Master from "../assets/Mastercard-Schwarz.png";

import Plane from "../assets/plane.png";
import Train from "../assets/train.png";
import Cruise from "../assets/cruise.png";

import PlaneSVG from "../assets/plane.svg";
import TrainSVG from "../assets/train.svg";
import CruiseSVG from "../assets/cruise.svg";

//let content = [Visa, Diner, Master];

let content = [Plane, Train, Cruise];

//let content = [PlaneSVG, TrainSVG, CruiseSVG];

let contentidx = 0;

const imgchange = () => {
  let tmp = document.getElementsByClassName("animationpic");
  if (tmp.length > 0) {
    for (let i = 0; i < tmp.length; i++) {
      tmp[i].style.display = "none";
    }
    if (contentidx === content.length - 1) {
      contentidx = 0;
    } else {
      contentidx++;
    }
    tmp[contentidx].style.display = "block";
  }
  setTimeout(imgchange, 2000);
};

imgchange();

export default function Loading1(props) {
  return (
    <>
      <div
        style={{
          width: "170px",
          height: "100px",
          margin: "auto",
          marginTop: "10%",
        }}
      >

        <img
          className="animationpic"
          src={content[0]}
          style={{ height: "100px" }}
        ></img>
        <img
          className="animationpic"
          src={content[1]}
          style={{ height: "100px" }}
        ></img>
        <img
          className="animationpic"
          src={content[2]}
          style={{ height: "100px" }}
        ></img>
      </div>
      <div style={{ height: "100px", width: "600px", margin: "auto" }}>
        {props.text ? <span style={{ fontSize: "1em" }}>{props.text}</span> : undefined}
      </div>
    </>
  );
}
